import { CanActivateFn, Router, Routes } from '@angular/router';
import { MAIN_CONTAINER_PAGE_ROUTES } from './pages-core';
import { inject } from '@angular/core';
import { ErrorRecoveryPageComponent } from '@imagise/features';

const langGuard: CanActivateFn = route => {
  const allowed = ['en', 'ru', 'es', 'fr', 'zh'];
  const lang = route.paramMap.get('lang');
  const router = inject(Router);

  if (lang && allowed.includes(lang)) {
    return true;
  }
  return router.parseUrl('/');
};

export const appRoutes: Routes = [
  {
    path: 'logging-in',
    pathMatch: 'full',
    loadComponent: () => import('./auth/auth-callback.component').then(m => m.AuthCallbackComponent),
  },
  { path: 'error', component: ErrorRecoveryPageComponent },
  { path: '', children: MAIN_CONTAINER_PAGE_ROUTES },
  { path: ':lang', children: MAIN_CONTAINER_PAGE_ROUTES, canActivate: [langGuard] },
  { path: '**', redirectTo: '' },
];
